import { BROKER_LINKS } from "@/data/brokers";
import { BROKERS } from '@/mocks/marketCalendar';
import { SectionHeading } from './ui';

export default function BrokerSection() {
  return (
    <section className="rounded-3xl border border-slate-200/80 bg-white p-6 md:p-8">
      <SectionHeading
        eyebrow="Nhà môi giới"
        title="Tìm hiểu điều kiện giao dịch"
        subtitle="Tìm hiểu thêm về nền tảng, Spread, Commission, Leverage và điều kiện giao dịch của các nhà môi giới."
      />

      <div className="mt-6 grid grid-cols-1 gap-4 md:grid-cols-3">
        {BROKERS.map((b) => (
          <div key={b.name} className="flex flex-col rounded-2xl border border-slate-200/80 bg-slate-50/50 p-5">
            <div className="flex items-center gap-3">
              <span
                className="flex h-11 w-11 items-center justify-center rounded-xl font-display text-base font-bold text-white"
                style={{ backgroundColor: b.color }}
              >
                {b.initial}
              </span>
              <div>
                <p className="text-sm font-bold text-slate-800">{b.name}</p>
                <p className="text-[11px] text-slate-400">{b.regulation}</p>
              </div>
            </div>

            <div className="mt-4 space-y-2.5">
              <Spec label="Nền tảng" value={b.platform} />
              <Spec label="Spread" value={b.spread} />
              <Spec label="Commission" value={b.commission} />
              <Spec label="Đòn bẩy" value={b.leverage} />
            </div>

            <div className="mt-5 flex gap-2">
              <a href={BROKER_LINKS[b.name]||'#'} className="flex-1 text-center whitespace-nowrap rounded-lg bg-violet-600 px-3 py-2 text-xs font-semibold text-white transition-colors hover:bg-violet-700">
                Mở tài khoản
              </a>
            </div>
          </div>
        ))}
      </div>

      <p className="mt-6 text-[11px] leading-relaxed text-slate-400">
        Lịch thị trường và các dữ liệu sự kiện được cung cấp nhằm mục đích thông tin. Thời gian, dự báo và dữ liệu thực tế có
        thể thay đổi tùy theo nguồn dữ liệu. Người dùng nên kiểm tra dữ liệu mới nhất trước khi đưa ra quyết định giao dịch.
      </p>
    </section>
  );
}

function Spec({ label, value }: { label: string; value: string }) {
  return (
    <div className="flex items-center justify-between gap-2 border-b border-slate-200/60 pb-2 text-xs">
      <span className="text-slate-400">{label}</span>
      <span className="text-right font-medium text-slate-700">{value}</span>
    </div>
  );
}